import { useFetchLoans } from "../../hooks/fetch-data/useFetchLoans";
import { useTranslation } from "react-i18next";
import SEO from "../../components/seo/SEO";
import LoanDetail from "./LoanDetail";

const PicoLoanDetailPage = () => {
  const { t } = useTranslation("loanDetail");

  const { data: loans, isFetching: isFetchingLoans } = useFetchLoans();

  const loanInfo = loans?.[1]; // Second product

  return (
    <>
      <SEO
        title={t("pico.title")}
        description={t("pico.description")}
        url={window.location.href}
        imageUrl={`${window.location.origin}/assets/img/ci/icon/icon-aunjai.svg`}
      />
      <LoanDetail loanInfo={loanInfo} isFetchingLoans={isFetchingLoans} />
    </>
  );
};

export default PicoLoanDetailPage;
